"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hyperapp_1 = require("../../../hyperapp");
const tab_1 = require("./tab");
exports.View = ({ state, actions, translate, tabs }) => (hyperapp_1.h(tab_1.Tab, { translate: translate, tabUiState: state.ui.tabs[state.ui.currentTabName], tabState: state.tabs[state.ui.currentTabName], actions: actions, tab: tabs.filter(tab => tab.name === state.ui.currentTabName)[0] }));
//# sourceMappingURL=view.js.map